module.exports = __webpack_public_path__ + "static/media/b-block.6ca00660.jpeg";